export default __webpack_public_path__ + "static/media/matching.6de5b859.md";